import Content from "Types/Content";
import Carousel from "Componentes/CarouselFede/Carousel";
import InfoList from "Contents/JiraTracking/Helpers/CarouselInfoList";

const JiraTrackingGide = () => {
  return (
    <div className='container-fluid'>
      <Carousel items={InfoList} indicators={true} arrows={true} />
    </div>
  );
};

export default new Content({
  Component: JiraTrackingGide,
  title: "Jira Tracking Guide",
  route: "jira-tracking",
  tags: ["Jira", "Trackeo", "trainee", "entrenamiento", "carousel"]
});
